// eslint-disable-next-line max-classes-per-file
export const ErrorCode = {
    INSUFFICIENT_FUNDS: '0x1',
};
export class ChainError extends Error {
    constructor(message, errorCode) {
        super(message);
        this.errorCode = errorCode;
        Object.setPrototypeOf(this, ChainError.prototype); // required for instance checking
    }
}
export class AlreadyRefreshedError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, AlreadyRefreshedError.prototype); // required for instance checking
    }
}
export class AbortedError extends Error {
    constructor() {
        super('Abort controller aborted');
        Object.setPrototypeOf(this, AbortedError.prototype); // required for instance checking
    }
}
export const throwIfAborted = (controller) => (result) => {
    if (controller.signal.aborted)
        throw new AbortedError();
    return Promise.resolve(result);
};
